<div class="input-section">
  <div class="input-column primary">
    <input #hourInput [value]="hour" (input)="handleHourInput($event)" type="tel" placeholder="--"
      [attr.inputmode]="useCustomKeyboard() ? 'none' : 'tel'" (focus)="onInputFocused(true)"
      (focusin)="onFocusIn($event)" (blur)="onInputLostFocus(true); onInputBlur($event)" maxlength="2"
      [disabled]="disabled" />
  </div>
  <div>:</div>
  <div class="input-column secondary">
    <input #minuteInput [value]="minute" (input)="handleMinuteInput($event)" type="tel" placeholder="--"
      [attr.inputmode]="useCustomKeyboard() ? 'none' : 'tel'" (focus)="onInputFocused(false)"
      (focusin)="onFocusIn($event)" (blur)="onInputLostFocus(false); onInputBlur($event)" maxlength="2"
      [disabled]="disabled" />
  </div>
</div>
<div class="format-column" tappable (click)="!disabled && presentFormatPopover($event)">
  <span class="format-label">{{ formatLabel }}</span><cs-icon name="arrow-dropdown"></cs-icon>
</div>